export const EVENTS = {
  sessionStart: 'session_start',
  onboardingStarted: 'OnboardingStarted',
  onboardingStartedSubmitted: 'OnboardingStartedSubmitted',
  onboardingQuestionPageSubmitted: 'question_page_completed',
  onboardingFactPageSubmitted: 'fact_page_completed',
  onboardingRoleShown: "OnboardingRoleShown",
  onboardingRoleSubmitted: "OnboardingRoleSubmitted",
  onboardingRoleSkip: "OnboardingRoleSkip",
  onboardingLocationsShown: "OnboardingLocationsShown",
  onboardingLocationsSubmitted: "OnboardingLocationsSubmitted",
  onboardingLocationsSkip: "OnboardingLocationsSkip",
  onboardingReasonShown: "OnboardingReasonShown",
  onboardingReasonSubmitted: "OnboardingReasonSubmitted",
  onboardingReasonSkip: "OnboardingReasonSkip",
  onboardingCheckTimeShown: "OnboardingCheckTimeShown",
  onboardingCheckTimeSubmitted: "OnboardingCheckTimeSubmitted",
  onboardingCheckTimeSkip: "OnboardingCheckTimeSkip",
  onboardingUpdatesShown: "OnboardingUpdatesShown",
  onboardingUpdatesSubmitted: "OnboardingUpdatesSubmitted",
  onboardingUpdatesSkip: "OnboardingUpdatesSkip",
  onboardingInappropriateShown: "OnboardingInappropriateShown",
  onboardingInappropriateSubmitted: "OnboardingInappropriateSubmitted",
  onboardingInappropriateSkip: "OnboardingInappropriateSkip",
  onboardingQuantityShown: "OnboardingQuantityShown",
  onboardingQuantitySubmitted: "OnboardingQuantitySubmitted",
  onboardingQuantitySkip: "OnboardingQuantitySkip",
  onboardingFeatureListShown: "OnboardingFeatureListShown",
  onboardingFeatureListSubmitted: "OnboardingFeatureListSubmitted",
  onboardingFeatureListSkip: "OnboardingFeatureListSkip",
  OnboardingReceivedAnswersShown: "OnboardingReceivedAnswersShown",
  onboardingReceivedAnswersSubmitted: "OnboardingReceivedAnswersSubmitted",
  onboardingCheckLocation: 'OnboardingCheckLocation',
  onboardingCheckLocationSubmitted: "OnboardingCheckLocationSubmitted",
  onboardingPlacesShown: 'OnboardingPlacesShown',
  onboardingPlacesSubmitted: 'OnboardingPlacesSubmitted',
  onboardingSosShown: "OnboardingSosShown",
  onboardingSosSubmitted: "OnboardingSosSubmitted",
  onboardingPlatformsShown: "OnboardingPlatformsShown",
  onboardingPlatformsSubmitted: "OnboardingPlatformsSubmitted",
  onboardingLookingforShown: "OnboardingLookingforShown",
  onboardingAprxLocationShown: "OnboardingAprxLocationShown",
  onboardingAprxLocationSubmitted: "OnboardingAprxLocationSubmitted",
  onboardingAboutusShown: "OnboardingAboutusShown",
  onboardingAboutusSubmitted: "OnboardingAboutusSubmitted",
  onboardingQ1Shown: "OnboardingQ1Shown",
  onboardingQ1Submitted: "OnboardingQ1Submitted",
  onboardingQ2Shown: "OnboardingQ2Shown",
  onboardingQ2Submitted: "OnboardingQ2Submitted",
  onboardingQ3Shown: "OnboardingQ3Shown",
  onboardingQ3Submitted: "OnboardingQ3Submitted",
  onboardingQ4Shown: "OnboardingQ4Shown",
  onboardingQ4Submitted: "OnboardingQ4Submitted",
  onboardingQ5Shown: "OnboardingQ5Shown",
  onboardingQ5Submitted: "OnboardingQ5Submitted",
  onboardingQ6Shown: "OnboardingQ6Shown",
  onboardingQ6Submitted: "OnboardingQ6Submitted",
  onboardingQ7Shown: "OnboardingQ7Shown",
  onboardingQ7Submitted: "OnboardingQ7Submitted",
  onboardingQ8Shown: "OnboardingQ8Shown",
  onboardingQ8Submitted: "OnboardingQ8Submitted",
  onboardingF1Shown: "OnboardingF1Shown",
  onboardingF1Submitted: "OnboardingF1Submitted",
  onboardingQ9Shown: "OnboardingQ9Shown",
  onboardingQ9Submitted: "OnboardingQ9Submitted",
  onboardingQ10Shown: "OnboardingQ10Shown",
  onboardingQ10Submitted: "OnboardingQ10Submitted",
  onboardingQ11Shown: "OnboardingQ11Shown",
  onboardingQ11Submitted: "OnboardingQ11Submitted",
  onboardingQ12Shown: "OnboardingQ12Shown",
  onboardingQ12Submitted: "OnboardingQ12Submitted",
  onboardingF2Shown: "OnboardingF2Shown",
  onboardingF2Submitted: "OnboardingF2Submitted",
  onboardingQ13Shown: "OnboardingQ13Shown",
  onboardingQ13Submitted: "OnboardingQ13Submitted",
  onboardingQ14Shown: "OnboardingQ14Shown",
  onboardingQ14Submitted: "OnboardingQ14Submitted",
  onboardingQ15Shown: "OnboardingQ15Shown",
  onboardingQ15Submitted: "OnboardingQ15Submitted",
  onboardingQ16Shown: "OnboardingQ16Shown",
  onboardingQ16Submitted: "OnboardingQ16Submitted",
  onboardingQ17Shown: "OnboardingQ17Shown",
  onboardingQ17Submitted: "OnboardingQ17Submitted",
  onboardingQ18Shown: "OnboardingQ18Shown",
  onboardingQ18Submitted: "OnboardingQ18Submitted",
  onboardingF3Shown: "OnboardingF3Shown",
  onboardingF3Submitted: "OnboardingF3Submitted",
  onboardingQ19Shown: "OnboardingQ19Shown",
  onboardingQ19Submitted: "OnboardingQ19Submitted",
  onboardingQ20Shown: "OnboardingQ20Shown",
  onboardingQ20Submitted: "OnboardingQ20Submitted",
  onboardingQ21Shown: "OnboardingQ21Shown",
  onboardingQ21Submitted: "OnboardingQ21Submitted",
  onboardingQ22Shown: "OnboardingQ22Shown",
  onboardingQ22Submitted: "OnboardingQ22Submitted",
  onboardingScoreShown: "OnboardingScoreShown",
  onboardingScoreSubmitted: "OnboardingScoreSubmitted",
  onboardingEnterEmailShown: 'OnboardingEnterEmailShown',
  onboardingEnterEmailSubmitted: 'OnboardingEnterEmailSubmitted',
  signupSuccess: 'AccountCreated',
  creatingProfileShown: 'CreatingProfileShown',
  onboardingPaywallShown: 'OnboardingPaywallShown',
  onboardingPaywallChosen: 'OnboardingPaywallChosen',
  onboardingCheckoutShown: 'OnboardingCheckoutShown',
  subBuyTapped: 'SubBuyTapped',
  subscribed: 'PaywallSubscribed',
  subBuyClosed: 'PaywallClosed',
  cardMethodChosen: 'CardCheckoutChosen',
  paymentAnimationScreen: 'PaymentAnimationScreen',
  onboardingPaymentDecline: 'OnboardingPaymentDecline',
  onboardingDeclineTryAgain: 'OnboardingDeclineTryAgain',
  upsellView: 'UpsellView',
  upsellTapped: 'UpsellTapped',
  upsellTappedClose: 'UpsellCloseTapped',
  upsellPurchased: 'UpsellPurchased',
  upsellFailed: 'UpsellPurchasedFailed',
  secondUpsellView: 'SecondUpsellView',
  secondUpsellTapped: 'SecondUpsellTapped',
  secondUpsellCloseTapped: 'SecondUpsellCloseTapped',
  secondUpsellPurchased: 'SecondUpsellPurchased',
  secondUpsellPurchasedFailed: 'SecondUpsellPurchasedFailed',
  skipTrialGetPlanShown: 'SkipTrialGetPlanShown',
  skipTrialGetPlanTapped: 'SkipTrialGetPlanTapped',
  skipTrialGetPlanClose: 'SkipTrialGetPlanClose',
  skipTrialGetPlanDiscountedShown: 'SkipTrialGetPlanDiscountedShown',
  skipTrialGetPlanDiscountedTapped: 'SkipTrialGetPlanDiscountedTapped',
  skipTrialGetPlanDiscountedClose: 'SkipTrialGetPlanDiscountedClose',
  onboardingSuccessShown: 'OnboardingSuccessShown',
  onboardingDone: 'OnboardingDone',
  popupEvent: 'payment_successful_popup',
}